// Module
var code = "<select ng-options=\"m.id as m.name for m in vm.months\"\n        ng-model=\"vm.model\"></select>";
// Exports
module.exports = code;